var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"popup-detail",attrs:{"id":"popupDetail"}},[_c('img',{staticClass:"close-popup",attrs:{"src":require('@/assets/icon/icon-close-properties.svg'),"width":"20","height":"20"},on:{"click":function($event){_vm.$emit('close-popup')}}}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72edd680","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/jPopupDetail.vue
// module id = KE40
// module chunks = 46